module.exports = __webpack_public_path__ + "img/BannerCV600X700px.cb2bd0fe.jpg";